import { Injectable } from '@angular/core';
import { CustomActiveCartService } from '@cart/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OrderActions } from '@order/data-access';
import { RoutingService } from '@spartacus/core';
import { tap } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RepeatOrderSuccessEffect {
  reloadCart$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(OrderActions.ONLINE_ORDER_REPEAT_SUCCESS, OrderActions.OFFLINE_ORDER_REPEAT_SUCCESS),
        map(() => this.activeCartService.reloadActiveCart()),
        tap(() => this.routingService.go('cart')),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private activeCartService: CustomActiveCartService,
    private routingService: RoutingService,
  ) {}
}
